import './Badge.css'

export default function Badge({ children, style = {} }) {
  return (
    <span className="pcbadge" style={style}>
      {children}
    </span>
  )
}
